export default __webpack_public_path__ + "static/media/IMG_2029.25d12e9b.JPG";